<template>
  <div>
    <label class="typo__label" for="sector">Zone de prospection</label>
    <multiselect
      v-model="selectedSector"
      id="sector"
      label="place_name"
      track-by="id"
      placeholder="Écrivez un code postal pour chercher un secteur"
      open-direction="bottom"
      :options="options"
      :multiple="false"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :clear-on-select="false"
      :close-on-select="true"
      :options-limit="5"
      :limit="1"
      :max-height="600"
      :show-no-results="false"
      :hide-selected="true"
      @search-change="asyncFind"
      :show-no-options="false"
    >
    </multiselect>
    <input v-if="selectedSector" :value="JSON.stringify(this.selectedSector)" name="website_mb_feature" type="text" style="display: none;">
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  props: {
    initialValue: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      selectedSector: null,
      options: [],
      isLoading: false,
    };
  },
  methods: {
    asyncFind(query) {
      if (!query || query === '' || query.length < 3) {
        return
      }

      this.isLoading = true;

      axios
        .get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=pk.eyJ1IjoiYXdxayIsImEiOiJjazhxYzFoM3YwMXZqM2tvNWwxbjdmd3UxIn0.8DA4-vZr79aPkF9Ylf4YWA&limit=5&types=postcode&country=fr%2Cgf%2Cpf%2Ctf%2Cgp%2Cre`
        )
        .then((response) => {
          if (response && response.data) {
            if (response.data.features) {
              this.options = response.data.features;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    if (this.initialValue) {
      if (this.initialValue !== '') {
        const decoded = JSON.parse(this.initialValue)

        this.selectedSector = decoded
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.multiselect__option--selected {
  color: var(--gray-dark);
  font-weight: 500;
}

.option__title {
  font-size: 0.9375rem;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin-bottom: 0.1875rem;
}

.option__small {
  font-size: 0.8375rem;
}

.multiselect.is-invalid {
  .multiselect__tags {
    border-color: var(--danger);
  }
}
</style>
